<!-- FORMULARIO DATOS UBER -->
<form
  action=""
  autocomplete="off"
  class="form"
  [formGroup]="formStepDataUberLto"
>
  <div>
    <p>
      Para acelerar la captura de tu información podemos a través de nuestro
      convenio con Uber, acceder a información general de tu perfil que te
      ahorrará la captura de información.
    </p>
    <div class="text-check">
      <p>Permite que Vemo pueda acceder a tus datos de UBER</p>
      <button
        id="boton-uber"
        type="button"
        class="boton-siguiente"
        (click)="openDialogUber(); clicked = true"
        [disabled]="clicked"
      >
        <img src="assets/images/iconoUber.png" /> Conectar a Uber
      </button>
    </div>
  </div>
  <div>
    <p>
      En caso de no contar con cuenta en Uber no eres candidato para aplicar
      para un crédito. regresa cuando cumplas con los siguientes requisitos:
    </p>
    <ul>
      <li>Al menos 3 meses activo en la aplicación.</li>
      <li>Al menos 1,800 viajes en la aplicación.</li>
      <li>Tener una edad mínima de 24 años.</li>
    </ul>
  </div>
</form>
